module.exports = __webpack_public_path__ + "static/haldimandLogo-7aaa88bdaaf5fc422be426bdd5459d6e.png";